import type {ReactElement} from 'react';
import React, { useRef} from 'react';
import ShapeMaskingEditingPanel from '@Panels/masking-panel/components/shape-masking-editing-panel';
import ShapeMaskingCanvas from '@Panels/masking-panel/components/shape-masking-canvas/shape-masking-canvas';
import type {CropData} from '@PosterWhiteboard/classes/item-crop.class';
import type {MaskingShapeObject} from '@PosterWhiteboard/classes/masking/masking-shape.class';
import type {ContainerQueryObject} from '@Hooks/useContainerQuery';
import { useContainerQuery} from '@Hooks/useContainerQuery';
import styles from './shape-masking-panel.module.scss';

const query: ContainerQueryObject = {
  small: {
    maxWidth: 499,
  },
};

export interface ShapeMaskingPanelProps {
  imageUrl: string;
  initialMaskingData?: MaskingShapeObject;
  cropData?: CropData;
  className?: string;
}

export const SHAPE_MASKING_CANVAS_ID = 'shape-masking-canvas';

function ShapeMaskingPanel({className = '', ...props}: ShapeMaskingPanelProps): ReactElement {
  const containerRef = useRef<HTMLDivElement>(null);
  const params = useContainerQuery(containerRef, query);

  return (
    <div
      ref={containerRef}
      className={`${params.small ? styles.smallTool : styles.bigTool} ${params.small ? 'flex-items-center flex-column-reverse' : ''} ${className} flexbox _full-width _full-height`}
    >
      <ShapeMaskingEditingPanel isSmall={params.small} />
      <ShapeMaskingCanvas
        className="flex-1"
        isSmallScreen={params.small}
        id={SHAPE_MASKING_CANVAS_ID}
        url={props.imageUrl}
        initialMaskingData={props.initialMaskingData}
        cropData={props.cropData}
      />
    </div>
  );
}

export default ShapeMaskingPanel;
